<template>
  <div>
    <HomeBanner id="HomeBanner" />
    <v-divider></v-divider>
    <About id="About" />
    <v-divider></v-divider>
    <Features id="Features" />
    <Join id="Join" />
    <v-divider></v-divider>
    <Banner id="Banner" />
    <Pricing id="Pricing" />
    <Contact id="Contact" />
  </div>
</template>

<script>
import HomeBanner from '../components/HomeBanner';
import About from '../components/About';
import Features from '../components/Features';
import Join from '../components/Join';
import Banner from '../components/Banner';
import Pricing from '../components/Pricing';
import Contact from '../components/ContactUs';

export default {
  components: {
    HomeBanner,
    About,
    Features,
    Join,
    Banner,
    Pricing,
    Contact
  },
};
</script>
